var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12 mb-2" },
            [
              _c(
                "router-link",
                {
                  staticClass: "link",
                  attrs: {
                    to: _vm.$laravelRoute(
                      "favourites.index",
                      { user_id: _vm.user.id },
                      false
                    )
                  }
                },
                [_vm._v("Favourites")]
              ),
              _vm._v(" "),
              _vm.$userIsRole("admin")
                ? _c(
                    "router-link",
                    {
                      staticClass: "link",
                      attrs: {
                        to: _vm.$laravelRoute(
                          "user-bid.index",
                          { rep_id: _vm.user.id },
                          false
                        )
                      }
                    },
                    [_vm._v("Bids")]
                  )
                : _c(
                    "router-link",
                    {
                      staticClass: "link",
                      attrs: {
                        to: _vm.$laravelRoute(
                          "user-bid.index",
                          { filter_user_ids: _vm.user.id },
                          false
                        )
                      }
                    },
                    [_vm._v("Bids")]
                  ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link",
                  attrs: {
                    href: _vm.$laravelRoute(
                      "history.by-user",
                      { user: _vm.user.id },
                      false
                    )
                  }
                },
                [_vm._v("Activity")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "link",
                  attrs: {
                    to: _vm.$laravelRoute(
                      "saved-search.index",
                      { user_id: _vm.user.id },
                      false
                    )
                  }
                },
                [_vm._v("Saved Searches")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "link",
                  attrs: {
                    to: _vm.$laravelRoute(
                      "recommended.index",
                      { user_id: _vm.user.id },
                      false
                    )
                  }
                },
                [_vm._v("Recommended")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "link",
                  attrs: {
                    to: _vm.$laravelRoute(
                      "auto-notices.index",
                      { user_id: _vm.user.id },
                      false
                    )
                  }
                },
                [_vm._v("Auto Notices")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "link",
                  attrs: {
                    to: _vm.$laravelRoute(
                      "vehicle-stock.myGarage",
                      { user_id: _vm.user.id },
                      false
                    )
                  }
                },
                [_vm._v("My Stock")]
              ),
              _vm._v(" "),
              _vm.$userIsAdmin()
                ? _c(
                    "router-link",
                    {
                      staticClass: "link",
                      attrs: {
                        to: _vm.$laravelRoute("users.edit", _vm.user.id, false)
                      }
                    },
                    [_vm._v("Edit")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "p",
                [
                  _c("strong", [_vm._v("Company: ")]),
                  _vm._v(" "),
                  _vm.user.company
                    ? [_vm._v(" " + _vm._s(_vm.user.company.name) + " ")]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("First name: ")]),
                _vm._v(" " + _vm._s(_vm.user.first_name))
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Last name: ")]),
                _vm._v(" " + _vm._s(_vm.user.last_name))
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("strong", [_vm._v("Status: ")]),
                  _vm._v(" "),
                  _vm.user.status
                    ? [_vm._v(_vm._s(_vm.user.status.name))]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("strong", [_vm._v("Role: ")]),
                  _vm._v(" "),
                  _vm.user.role
                    ? [_vm._v(_vm._s(_vm.user.role.name))]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v("Email: ")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "mailto:" + _vm.user.email,
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.user.email) +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.user.profile
                ? [
                    _c("p", [
                      _c("strong", [_vm._v("Phone: ")]),
                      _vm._v(" " + _vm._s(_vm.user.profile.phone))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("strong", [_vm._v("Fax: ")]),
                      _vm._v(" " + _vm._s(_vm.user.profile.fax))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("strong", [_vm._v("Mobile: ")]),
                      _vm._v(" " + _vm._s(_vm.user.profile.mobile))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("strong", [_vm._v("Address: ")]),
                      _vm._v(" " + _vm._s(_vm.user.profile.address))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("strong", [_vm._v("City: ")]),
                      _vm._v(" " + _vm._s(_vm.user.profile.city))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("strong", [_vm._v("Post Code: ")]),
                      _vm._v(" " + _vm._s(_vm.user.profile.post_code))
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("strong", [_vm._v("Country: ")]),
                        _vm._v(" "),
                        _vm.user.country
                          ? [_vm._v(_vm._s(_vm.user.country.name))]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _c("strong", [_vm._v("Customer Region: ")]),
                        _vm._v(" "),
                        _vm.user.profile.region
                          ? [_vm._v(_vm._s(_vm.user.profile.region))]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("p", [
              _c("strong", [_vm._v("Username: ")]),
              _vm._v(" " + _vm._s(_vm.user.username))
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Sales Rep: ")]),
              _vm._v(" "),
              _vm.user.sales_rep
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$laravelRoute(
                          "users.show",
                          _vm.user.sales_rep_id
                        )
                      }
                    },
                    [_vm._v(_vm._s(_vm.user.sales_rep.name))]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Last Activity: ")]),
              _vm._v(" " + _vm._s(_vm.user.last_activity))
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("User ID ")]),
              _vm._v(" " + _vm._s(_vm.user.id))
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Owner Key: ")]),
              _vm._v(" " + _vm._s(_vm.user.ownerkey))
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Bid Color ")]),
              _vm._v(" " + _vm._s(_vm.user.profile.bid_color))
            ]),
            _vm._v(" "),
            _c(
              "p",
              [
                _c("strong", [_vm._v("Bump bid")]),
                _vm._v(" "),
                _vm.user.bump_bid && _vm.user.bump_bid.text_array.length
                  ? [
                      _c("br"),
                      _vm._v(" "),
                      _vm._l(_vm.user.bump_bid.text_array, function($txt) {
                        return _c("span", [
                          _vm._v(
                            "\n                        " +
                              _vm._s($txt) +
                              "\n                        "
                          ),
                          _c("br")
                        ])
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("h3", [_vm._v("End Consumer Privileges")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.enable_auto_notice ? "YES" : "NO") +
                  " - Enable Auto Notice"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.enable_market_price ? "YES" : "NO") +
                  " - Enable Market Price Research"
              )
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Dealer Privileges")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm.user.privileges.display_auction_result ? "YES" : "NO"
                ) + " - Display Auction Results"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.enable_email ? "YES" : "NO") +
                  " - Enable Email"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.show_auction_site ? "YES" : "NO") +
                  " - Show Auction Site"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.show_lot_number ? "YES" : "NO") +
                  " - Show Lot Number"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.show_inspection ? "YES" : "NO") +
                  " - Show Inspection"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.add_url_logo_image ? "YES" : "NO") +
                  " - Add URL Logo Image"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.attended_auctions ? "YES" : "NO") +
                  " - Attended Auctions"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.show_history ? "YES" : "NO") +
                  " - Show History"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.can_login_as ? "YES" : "NO") +
                  " - Can Login As Another User"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(_vm.user.privileges.unlimited_login ? "YES" : "NO") +
                  " - Unlimited Login"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _vm.user.profile && _vm.user.profile.note
              ? _c("strong", [
                  _vm._v("Notes: " + _vm._s(_vm.user.profile.note))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8751101e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8751101e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/ShowUser.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8751101e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/User/ShowUser.vue
// module chunks = 0